import { render, staticRenderFns } from "./pvt_form_preview.vue?vue&type=template&id=45ef8934&"
import script from "./pvt_form_preview.vue?vue&type=script&lang=js&"
export * from "./pvt_form_preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports